import React, { useEffect, useState } from 'react';

import { Table } from '../../../../common/table/Table';

import './PastVisit.css';

export const FutureVisitSearch = ({ participant }) => {
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    if (participant) {
      setSearchResults(participant?.futureVisits);
    }
  }, [setSearchResults, participant]);

  return (
    <div className="visit-search">
      {searchResults && (
        <Table
          tableData={searchResults}
          hiddenColumns={['externalReference']}
          searchEnabled={true}
          filterEnabled={true}
          tableTitle={'Visits'}
          maxRowCount={6}
          horizontalScroll
        />
      )}
    </div>
  );
};
